
<div class="p-3">
  <h3 class="header">Confirmation</h3>
  <div class="tableContainer activeReturnRequest">
    <table mat-table #existingRequestTable [dataSource]="exisitingRecordsDataSource" class="matTables">
      <ng-container matColumnDef="returnRequestID">
        <th mat-header-cell *matHeaderCellDef class="returnId  text-left">Request ID</th>
        <td mat-cell *matCellDef="let element" class="text-left">
          <div class="order-info handCursor">
            <u>
              <p class="accNo">
                {{element.requestID}}
              </p>
            </u>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="customerPO">
        <th mat-header-cell *matHeaderCellDef class="customerPO  text-left">Customer PO#</th>
        <td mat-cell *matCellDef="let element" class="text-left"> {{element.customerPO}} </td>
      </ng-container>
      <ng-container matColumnDef="shipToLocation">
        <th mat-header-cell *matHeaderCellDef class="return-request text-left">Ship To Location</th>
        <td mat-cell *matCellDef="let element" class="order-info defaultCursor">
          <div class="order-info">
            <p class="accName">
              {{element.shipToAccountName}}
            </p>
            <p class="accAddress"> {{element.shipToAccountAddress1}}, {{element.shipToCity}}, {{element.shipToState}} {{element.shipToZipCode}}</p>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="shipToNumber">
        <th mat-header-cell *matHeaderCellDef class="customerPO  text-left">ShipTo Number</th>
        <td mat-cell *matCellDef="let element" class="text-left"> {{element.shipToAccountNo}} </td>
      </ng-container>
      <ng-container matColumnDef="deliverToLocation">
        <th mat-header-cell *matHeaderCellDef class="return-request text-left">Deliver To Location</th>
        <td mat-cell *matCellDef="let element" class="order-info defaultCursor">
          <div class="order-info">
            <p *ngIf="element.deliverToAccountNo" class="accName">
              {{element.deliverToAccountName}}
            </p>
            <p class="accAddress" *ngIf="element.deliverToAccountNo"> {{element.deliverToAccountAddress1}}, {{element.deliverToCity}}, {{element.deliverToState}} {{element.deliverToZipCode}}</p>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="deliverToNumber">
        <th mat-header-cell *matHeaderCellDef class="customerPO  text-left">DeliverTo Number</th>
        <td mat-cell *matCellDef="let element" class="text-left"> {{element.deliverToAccountNo}} </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="exisitingCols;sticky:true;"></tr>
      <tr style="cursor:pointer;" mat-row *matRowDef="let row; columns: exisitingCols;" (click)="selectRow(row)"
          [class.selected-row]="selectedRow === row"></tr>
    </table>
  </div>
  <p class="m-0 p-0 confirmation-message">
    There is an existing open request for the selected account. Do you want to continue with that?
    If so, select the appropriate <strong>requestID</strong> line from above and click on <strong>Yes</strong>.
    Click on <strong>No</strong> to continue with creation of new request.
  </p>

  <div class="dialog-actions">
    <button mat-raised-button color="primary" [disabled]="!selectedRow" mat-button class="btns mat-raised-button" (click)="onYesClick()">Yes</button>
    <button mat-raised-button color="warn" (click)="onNoClick()" mat-button class="btns mat-raised-button">No</button>
  </div>
</div>

